import styled, { css } from 'styled-components';

import { tooltipTokens } from '../../tokens/components/Tooltip/tokens';

export const TooltipWrapper = styled.div`
  display: inline;
`;

export const TooltipTrigger = styled.div`
  display: inline-block;

  ${({ theme }) =>
    theme.tooltipBlock &&
    css`
      display: block;
    `}
`;

export const TooltipArrow = styled.div`
  position: absolute;

  &::after,
  &::before {
    border: solid transparent;
    content: '';
    display: block;
    height: 0;
    pointer-events: none;
    position: absolute;
    width: 0;
  }

  // Ignoring sort order to create an arrow using borders
  // stylelint-disable order/properties-alphabetical-order
  &::after {
    border-color: rgba(0, 0, 0, 0);
    border-width: 8px;
  }

  &::before {
    border-color: rgba(0, 0, 0, 0);
    border-width: calc(8px + ${tooltipTokens.ContainerBorderWidthBaseDefault});
  }
  // stylelint-enable order/properties-alphabetical-order
`;

export const TooltipContent = styled.div`
  font-size: ${tooltipTokens.ContainerFontSizeBaseDefault};
  font-weight: ${tooltipTokens.ContainerFontWeightBaseDefault};
  line-height: ${tooltipTokens.ContainerFontLeadingBaseDefault};
  background-color: ${tooltipTokens.ContainerBackgroundColorBaseDefault};
  border: ${tooltipTokens.ContainerBorderWidthBaseDefault} solid ${tooltipTokens.ContainerBorderColorBaseDefault};
  border-radius: ${tooltipTokens.ContainerBorderRadiusBaseDefault};
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  color: ${tooltipTokens.ContainerFontColorBaseDefault};
  max-width: 300px;
  padding: 10px 14px;
  white-space: normal;
  z-index: ${tooltipTokens.ContainerElevationBaseDefault};

  // Directions
  &[data-popper-placement='bottom'],
  &[data-popper-placement='top'] {
    ${TooltipArrow}::before,
    ${TooltipArrow}::after {
      transform: translateX(-50%);
    }
  }

  &[data-popper-placement='top'] {
    ${TooltipArrow},
    ${TooltipArrow}::after,
    ${TooltipArrow}::before {
      top: 100%;
    }

    ${TooltipArrow}::after {
      border-top-color: ${tooltipTokens.ContainerBackgroundColorBaseDefault};
    }

    ${TooltipArrow}::before {
      border-top-color: ${tooltipTokens.ContainerBorderColorBaseDefault};
    }

    margin-bottom: ${tooltipTokens.ContainerSpacingOuterBaseDefault};
  }

  &[data-popper-placement='bottom'] {
    ${TooltipArrow},
    ${TooltipArrow}::after,
    ${TooltipArrow}::before {
      bottom: 100%;
    }

    ${TooltipArrow}::after {
      border-bottom-color: ${tooltipTokens.ContainerBackgroundColorBaseDefault};
    }

    ${TooltipArrow}::before {
      border-bottom-color: ${tooltipTokens.ContainerBorderColorBaseDefault};
    }

    margin-top: ${tooltipTokens.ContainerSpacingOuterBaseDefault};
  }

  &[data-popper-placement='right'],
  &[data-popper-placement='left'] {
    ${TooltipArrow}::before,
    ${TooltipArrow}::after {
      transform: translateY(-50%);
    }
  }

  &[data-popper-placement='right'] {
    ${TooltipArrow},
    ${TooltipArrow}::after,
    ${TooltipArrow}::before {
      right: 100%;
    }

    ${TooltipArrow}::after {
      border-right-color: ${tooltipTokens.ContainerBackgroundColorBaseDefault};
    }

    ${TooltipArrow}::before {
      border-right-color: ${tooltipTokens.ContainerBorderColorBaseDefault};
    }

    margin-left: ${tooltipTokens.ContainerSpacingOuterBaseDefault};
  }

  &[data-popper-placement='left'] {
    ${TooltipArrow},
    ${TooltipArrow}::after,
    ${TooltipArrow}::before {
      left: 100%;
    }

    ${TooltipArrow}::after {
      border-left-color: ${tooltipTokens.ContainerBackgroundColorBaseDefault};
    }

    ${TooltipArrow}::before {
      border-left-color: ${tooltipTokens.ContainerBorderColorBaseDefault};
    }

    margin-right: ${tooltipTokens.ContainerSpacingOuterBaseDefault};
  }

  ${({ theme }) =>
    theme.isTable &&
    theme.tooltipVariant === 'feedback-negative' &&
    css`
      background: ${tooltipTokens.ContainerBackgroundColorNegativeDefault};
      border-color: ${tooltipTokens.ContainerBorderColorNegativeDefault};
      color: ${tooltipTokens.ContainerFontColorNegativeDefault};

      &[data-popper-placement='top'] {
        ${TooltipArrow}::after {
          border-top-color: ${tooltipTokens.ContainerBackgroundColorNegativeDefault};
        }

        ${TooltipArrow}::before {
          border-top-color: ${tooltipTokens.ContainerBorderColorNegativeDefault};
        }
      }

      &[data-popper-placement='bottom'] {
        ${TooltipArrow}::after {
          border-bottom-color: ${tooltipTokens.ContainerBackgroundColorNegativeDefault};
        }

        ${TooltipArrow}::before {
          border-bottom-color: ${tooltipTokens.ContainerBorderColorNegativeDefault};
        }
      }

      &[data-popper-placement='right'] {
        ${TooltipArrow}::after {
          border-right-color: ${tooltipTokens.ContainerBackgroundColorNegativeDefault};
        }

        ${TooltipArrow}::before {
          border-right-color: ${tooltipTokens.ContainerBorderColorNegativeDefault};
        }
      }

      &[data-popper-placement='left'] {
        ${TooltipArrow}::after {
          border-left-color: ${tooltipTokens.ContainerBackgroundColorNegativeDefault};
        }
        ${TooltipArrow}::before {
          border-left-color: ${tooltipTokens.ContainerBorderColorNegativeDefault};
        }
      }
    `}
`;
